module.exports = __webpack_public_path__ + "img/way_l.a73dbc2c.png";